import { AboutService } from './about/about.service';
import { BalanceAdjustmentService } from './balance-adjustment/balance-adjustment.service';
import { BreadcrumbService } from './breadcrumbs/breadcrumb.service';
import { C3Service } from './c3/c3.service';
import { CatalogueService } from './catalogue/catalogue.service';
import { CatalogueHistoryService } from './catalogue/catalogue_history.service';
import { CatalogueVersionService } from './catalogue/catalogue_version.service';
import { ChargeAccountActionsService } from './charge-account-actions/charge-account-actions.service';
import { ChargeAccountAutoTopupService } from './charge-account-auto-topup/charge-account-auto-topup.service';
import { ChargeAccountDeviceMappingsService } from './charge-account-device-mappings/charge-account-device-mappings.service';
import { ChargeAccountService } from './charge-account/charge-account.service';
import { CustomerSchemaService } from './customer/customer-schemas.service';
import { CustomerService } from './customer/customer.service';
import { DebtRecoveryService } from './debt-recovery/debt-recovery.service';
import { DecodedItsoMessageTranslationRequestService } from './decoded-itso-message-translation-request/decoded-itso-message-translation-request.service';
import { DecodedItsoMessageService } from './decoded-itso-message/decoded-itso-message.service';
import { DialogService } from './dialog/dialog.service';
import { EntitlementValidationService } from './entitlement-validation/entitlement-validation.service';
import { ExternalRefundsService } from './external-refunds/external-refunds.service';
import { ExternalTopUpsService } from './external-top-ups/external-top-ups.service';
import { FileBuilderService } from './file-builder/file-builder.service';
import { FileExporterUtilitiesService } from './file-exporting/file-exporter-utilities.service';
import { FileExporterService } from './file-exporting/file-exporter.service';
import { FileReaderService } from './file-reading/file-reader.service';
import { FileUploadService } from './file-upload/file-upload.service';
import { FulfilmentRequestsService } from './fulfilment/fulfilment.service';
import { ItsoRegistrationService } from './itso-registration/itso-registration.service';
import { JourneyConstructionRuleService } from './journey-construction-rule/journey-construction-rule.service';
import { JourneyUpdateService } from './journey-update/journey-update.service';
import { JourneyService } from './journey/journey.service';
import { KeycloakService } from './keycloak.service';
import { LinkBuilder } from './link-builder.service';
import { OrganisationService } from './organisation/organisation.service';
import { PaymentService } from './payments/payments.service';
import { PdfGeneratorService } from './pdf-generator.service';
import { PhotoService } from './photo/photo.service';
import { ProductSettlementPeriodService } from './product-settlement-period/product-settlement-period.service';
import { ProductSettlementRequestService } from './product-settlement-request/product-settlement-requests.service';
import { ProductSchemaService } from './product/product-schema.service';
import { ProductSearchService } from './product/product-search.service';
import { ProductService } from './product/product.service';
import { QueryBuilder } from './query-builder.service';
import { RailSettlementService } from './rail-settlement/rail-settlement.service';
import { ResourceHelperService } from './resource-helper.service';
import { SchemeService } from './scheme/scheme.service';
import { SecureUsageTokenService } from './secure-usage-token/secure-usage-token.service';
import { SpecialDayService } from './special-day/special-day.service';
import { TapTranslationRequestService } from './tap-translation-request/tap-translation-request.service';
import { TapService } from './tap/tap.service';
import { TicketService } from './tickets/ticket.service';
import { TimebandService } from './timebands/timeband.service';
import { ACTToolbarService } from './toolbar.service';
import { TransportLocationService } from './transport-location/transport-location.service';
import { TransportOperatorBusRouteService } from './transport-operator-route/transportOperatorRoute.service';
import { TransportOperatorServicesService } from './transport-operator-services/transport-operator-services.service';
import { TransportOperatorService } from './transport-operator/transport-operator.service';
import { TransportZoneService } from './transport-zone/transport-zone.service';
import { UsageEventCorrectionsService } from './usage-event-corrections/usage-event-corrections.service';
import { UsageEventService } from './usage-event/usage-event.service';
import { UsageRatingRulesService } from './usage-rating-rules/usage-rating-rules.service';
import { UsageEventProductMappingsService } from './usageEventProductMappings/usageEventProductMappings.service';
import { UserMessagesService } from './user-messages.service';
import { UserService } from './user/user.service';
import { VariantService } from './variant/variant.service';

export const initialise = () => {
  angular.module('actora.services', ['app.components', 'ngResource'])
    .config(['$qProvider', ($qProvider) => {
      $qProvider.errorOnUnhandledRejections(false);
    }])
    .factory('ticketService', ['$resource', ($resource) => { return new TicketService($resource); }])
    .factory('LinkBuilder', () => { return new LinkBuilder(); })
    .factory('aboutService', ['$resource', ($resource) => {
      return new AboutService($resource);
    }])
    .factory('balanceAdjustmentService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new BalanceAdjustmentService($resource, resourceHelperService);
    }])
    .factory('breadcrumbService', [() => {
      return new BreadcrumbService();
    }])
    .factory('customerService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new CustomerService($resource, resourceHelperService);
    }])
    .factory('chargeAccountActionsService', ['$resource', 'resourceHelperService', 'LinkBuilder', 'QueryBuilder', ($resource, resourceHelperService, LinkBuilder, queryBuilder) => {
      return new ChargeAccountActionsService($resource, resourceHelperService, LinkBuilder, queryBuilder);
    }])
    .factory('chargeAccountAutoTopupService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new ChargeAccountAutoTopupService($resource, resourceHelperService);
    }])
    .factory('paymentService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new PaymentService($resource, resourceHelperService);
    }])
    .factory('chargeAccountService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new ChargeAccountService($resource, resourceHelperService);
    }])
    .factory('secureUsageTokenService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new SecureUsageTokenService($resource, resourceHelperService);
    }])
    .factory('transportOperatorServicesService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new TransportOperatorServicesService($resource, resourceHelperService);
    }])
    .factory('customerSchemaService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => { return new CustomerSchemaService($resource, resourceHelperService); }])
    .factory('variantService', ['$resource', ($resource) => { return new VariantService($resource); }])
    .factory('transportOperatorBusRouteService', ['$resource', ($resource) => {
      return new TransportOperatorBusRouteService($resource);
    }])
    .factory('transportOperatorService', ['$resource', 'resourceHelperService', 'LinkBuilder',
      ($resource, resourceHelperService, LinkBuilder) => {
        return new TransportOperatorService($resource, resourceHelperService, LinkBuilder);
      }])
    .factory('fulfilmentRequestsService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new FulfilmentRequestsService($resource, resourceHelperService);
    }])
    .factory('productService', ['$resource', ($resource) => { return new ProductService($resource); }])
    .factory('productSchemaService', ['$resource', ($resource) => {
      return new ProductSchemaService($resource);
    }])
    .factory('productSearchService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new ProductSearchService($resource, resourceHelperService);
    }])
    .factory('journeyService', ['$resource', 'resourceHelperService', 'QueryBuilder',
      ($resource, resourceHelperService, queryBuilder) => {
        return new JourneyService($resource, resourceHelperService, queryBuilder);
      }])
    .factory('railSettlementService', ['$resource', 'userService', 'LinkBuilder', 'resourceHelperService',
      ($resource, userService, linkBuilder, resourceHelperService) => {
        return new RailSettlementService($resource, userService, linkBuilder, resourceHelperService);
      }])
    .factory('journeyUpdateService', ['$resource', 'resourceHelperService',
      ($resource, resourceHelperService) => {
        return new JourneyUpdateService($resource, resourceHelperService);
      }])
    .factory('fileBuilderService', ['$resource', ($resource) => { return new FileBuilderService($resource); }])
    .factory('catalogueVersionService', ['$resource', ($resource) => {
      return new CatalogueVersionService($resource);
    }])
    .factory('catalogueService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new CatalogueService($resource, resourceHelperService);
    }])
    .factory('catalogueHistoryService', ['$resource', ($resource) => { return new CatalogueHistoryService($resource); }])
    .factory('itsoRegistrationService', ['$resource', ($resource) => {
      return new ItsoRegistrationService($resource);
    }])
    .factory('c3Service', [() => {
      return new C3Service();
    }])
    .factory('fileExporterService', ['FileSaver', 'fileExporterUtilitiesService', (FileSaver, fileExporterUtilitiesService) => {
      return new FileExporterService(FileSaver, fileExporterUtilitiesService);
    }])
    .factory('userService', [
      'schemeService', '$resource', 'localStorageService', 'LinkBuilder', '$q', 'keycloakService', 'organisationService',
      (schemeService, $resource, localStorageService, LinkBuilder, $q, keycloakService, organisationService) => {
        return new UserService(schemeService, $resource, localStorageService, LinkBuilder, $q, keycloakService, organisationService);
      }])
    .factory('resourceHelperService', () => { return new ResourceHelperService(); })
    .factory('ACTToolbarService', ['$mdComponentRegistry', '$q', ($mdComponentRegistry, $q) => {
      return new ACTToolbarService($mdComponentRegistry, $q);
    }])
    .factory('QueryBuilder', ['LinkBuilder', (LinkBuilder) => { return new QueryBuilder(LinkBuilder); }])
    .factory('fileReaderService', ['$q', ($q) => new FileReaderService($q)])
    .factory('pdfGeneratorService', () => new PdfGeneratorService())
    .factory('fileExporterUtilitiesService', () => new FileExporterUtilitiesService())
    .factory('dialogService', [
      '$mdDialog', '$translate', '$injector',
      ($mdDialog, $translate, $injector) => {
        return new DialogService($mdDialog, $translate, $injector);
      }])
    .factory('keycloakService', ['$q', 'keycloakInstance', ($q, keycloakInstance) => {
      return new KeycloakService($q, keycloakInstance);
    }])
    .factory('photoService', ['$resource', ($resource) => { return new PhotoService($resource); }])
    .factory('organisationService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new OrganisationService($resource, resourceHelperService);
    }])
    .factory('schemeService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new SchemeService($resource, resourceHelperService);
    }])
    .factory('fileUploadService', ['$resource', 'Upload', '$q', '$rootScope', ($resource, Upload, $q, $rootScope) => {
      return new FileUploadService($resource, Upload, $q, $rootScope);
    }])
    .factory('UserMessages', ['$mdDialog', '$mdToast', '$document', '$translate', ($mdDialog, $mdToast, $document, $translate) => {
      return new UserMessagesService($mdDialog, $mdToast, $document, $translate);
    }])
    .factory('usageEventService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new UsageEventService($resource, resourceHelperService);
    }])
    .factory('tapService', ['$resource', ($resource) => {
      return new TapService($resource);
    }])
    .factory('tapTranslationRequestService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new TapTranslationRequestService($resource, resourceHelperService);
    }]).factory('productSettlementPeriodService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new ProductSettlementPeriodService($resource, resourceHelperService);
    }]).factory('productSettlementRequestService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new ProductSettlementRequestService($resource, resourceHelperService);
    }]).factory('journeyConstructionRuleService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new JourneyConstructionRuleService($resource, resourceHelperService);
    }]).factory('usageEventProductMappingsService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new UsageEventProductMappingsService($resource, resourceHelperService);
    }]).factory('transportZoneService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new TransportZoneService($resource, resourceHelperService);
    }]).factory('transportLocationService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new TransportLocationService($resource, resourceHelperService);
    }]).factory('timebandService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new TimebandService($resource, resourceHelperService);
    }]).factory('usageRatingRulesService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new UsageRatingRulesService($resource, resourceHelperService);
    }]).factory('specialDayService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new SpecialDayService($resource, resourceHelperService);
    }]).factory('decodedItsoMessageService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new DecodedItsoMessageService($resource, resourceHelperService);
    }]).factory('decodedItsoMessageTranslationRequestService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new DecodedItsoMessageTranslationRequestService($resource, resourceHelperService);
    }]).factory('debtRecoveryService', ['$resource', 'LinkBuilder', 'userService', ($resource, linkBuilder, userService) => {
      return new DebtRecoveryService($resource, linkBuilder, userService);
    }]).factory('usageEventCorrectionsService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new UsageEventCorrectionsService($resource, resourceHelperService);
    }]).factory('externalTopUpsService', ['$resource', ($resource) => {
      return new ExternalTopUpsService($resource);
    }]).factory('externalRefundsService', ['$resource', ($resource) => {
      return new ExternalRefundsService($resource);
    }]).factory('entitlementValidationService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new EntitlementValidationService($resource, resourceHelperService)
    }]).factory('chargeAccountDeviceMappingsService', ['$resource', 'resourceHelperService', ($resource, resourceHelperService) => {
      return new ChargeAccountDeviceMappingsService($resource, resourceHelperService)
    }]);
};
